import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputDisqualifiersText_disqualifierTextContainer: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(2, 0, 0, 0),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0),
			},
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			},
		},
		inputDisqualifiersText_checkboxListContainer: {
			display: 'inline-flex',
			flexDirection: 'column',
			width: '100%',
			margin: theme.spacing(3, 0)
		},
		inputDisqualifiersText_checkboxListBody: {
			display: 'inline-flex',
			flexWrap: 'wrap',
		},
		inputDisqualifiersText_checkboxListHelperText: {
			padding: theme.spacing(1, 0, 0, 0),
		},
		inputDisqualifiersText_checkboxContainer: {

		},
		inputDisqualifiersText_checkboxBody: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				minWidth: '175px',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				minWidth: '125px',
			},
		},
		inputDisqualifiersText_checkboxBodyAgree: {
			padding: theme.spacing(1.5, 1.5, 1.5, 0),
		},
		inputDisqualifiersText_checkboxBodyDisagree: {
			padding: theme.spacing(1.5, 0, 1.5, 1.5),
		},
	});
});

export default useStyles;
